import { assignSealed } from "./utils/assignSealed";
export class Field {
    constructor(name, options = {}) {
        this.name = name;
        assignSealed(this, options);
    }
}
//# sourceMappingURL=Field.js.map